import { useEffect, useRef, useState } from "react";
import logo from "../assets/logo.png";
import { useSpeechToText } from "../hooks/use-speech";

const socket = new WebSocket('wss://xw7jlviyq9.execute-api.us-west-1.amazonaws.com/dev');

const Home = () => {
  const [messages, setMessages] = useState<string[]>([]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const ws = useRef<WebSocket | null>(null);

  // Set up WebSocket connection
  useEffect(() => {
    ws.current = new WebSocket('wss://xw7jlviyq9.execute-api.us-west-1.amazonaws.com/dev');

    ws.current.onopen = () => {
      setMessages((prev) => [...prev, "🟢 Connected to TalkWise AI"]);
    };

    ws.current.onmessage = (event) => {
      setIsTyping(false);
      try {
        const parsed = JSON.parse(event.data);
        // Ignore 'thinking' type messages
        if (parsed.type === 'thinking') return;
        const aiMessage = parsed.data || parsed.message || parsed.reply || event.data;
        setMessages((prev) => [...prev, `🤖 ${aiMessage}`]);
      } catch {
        setMessages((prev) => [...prev, `🤖 ${event.data}`]);
      }
    };

    ws.current.onerror = () => {
      setMessages((prev) => [...prev, "❌ WebSocket error"]);
      setIsTyping(false);
    };

    ws.current.onclose = () => {
      setMessages((prev) => [...prev, "🔴 Disconnected"]);
    };

    return () => ws.current?.close();
  }, []);

  const handleSend = () => {
    const message = input.trim();
    if (!message || !ws.current || ws.current.readyState !== WebSocket.OPEN) {
      setMessages((prev) => [...prev, "⚠️ Cannot send: not connected"]);
      return;
    }

    setMessages((prev) => [...prev, `🧑 You: ${message}`]);
    setIsTyping(true);
    setInput("");

    ws.current.send(JSON.stringify({ action: "sendMessage", data: message }));
  };

  const { start } = useSpeechToText((result: string) => {
    setInput(result);
    // Optional: auto-send on voice end
    // handleSend();
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-accent to-white font-sans flex justify-center items-start text-textMain p-8">
      <div className="w-full max-w-xl bg-white rounded-2xl p-8 shadow-xl">
        <div className="text-center mb-8">
          <img src={logo} alt="TalkWise AI" className="w-16 mx-auto mb-2" />
          <h1 className="text-4xl font-bold text-[#1a1a2e]">
            <span className="text-[#1e3a8a]">Talk</span>
            <span className="text-[#a6a6a6]">Wise</span> AI
          </h1>
        </div>

        <div className="min-h-[200px] max-h-64 overflow-y-auto p-4 border border-accent rounded-lg bg-accent mb-4 flex flex-col gap-2">
          {messages.map((msg, i) => (
            <div
              key={i}
              className={`mb-2 px-4 py-2 rounded-lg ${
                msg.startsWith("🤖")
                  ? "bg-primary text-white self-start"
                  : "bg-white text-textMain self-end"
              }`}
            >
              {msg}
            </div>
          ))}
          {isTyping && (
            <div className="italic text-sm text-gray-500 self-start">
              TalkWise AI is typing...
            </div>
          )}
        </div>

        <div className="flex gap-2 mt-4">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message..."
            className="flex-1 px-4 py-2 border border-accent rounded-lg text-base"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSend();
            }}
          />
          <button
            onClick={handleSend}
            className="px-4 py-2 bg-primary text-white rounded-lg font-bold"
          >
            Send
          </button>
          <button
            onClick={start}
            className="px-4 py-2 bg-accent text-textMain rounded-lg font-bold"
            title="Speak"
          >
            🎤
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;